import { render, staticRenderFns } from "./football-collect.vue?vue&type=template&id=004db979&scoped=true&"
import script from "./football-collect.vue?vue&type=script&lang=js&"
export * from "./football-collect.vue?vue&type=script&lang=js&"
import style0 from "./football-collect.vue?vue&type=style&index=0&id=004db979&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004db979",
  null
  
)

export default component.exports